/**
 * @module geo/services
 */
import {Service} from '.';
import {FeatureTransactionService} from './feature.transaction';
import {SearchService} from './search';
import {GetImageMapService} from './get.image.map';

/**
 * Loader for service instances.
 * See [[GeoApp.getService]] and [[Functionality.getService]]
 */
export class ServiceLoader {
  /**
   * Get Service controler instance by type and GeoApp uid
   *
   */
  static getServiceInstance<S extends Service>(
      classname: string, uid: string, options?: any): S {
    if (!ServiceTypes[classname]) {
      throw new Error('Service ' + classname + ' not found');
    }
    const serviceId = classname + '_' + uid;
    if (!servicesInstances[serviceId]) {
      servicesInstances[serviceId] =
          new ServiceTypes[classname](options, serviceId);
    }
    return servicesInstances[serviceId];
  }
}

export interface IHashServices<S extends Service> {
  [serviceId: string]: S;
}

const servicesInstances: IHashServices<any> = {};

export const ServiceTypes: any = {
  'Search': SearchService,
  'FeatureTransaction': FeatureTransactionService,
  'GetImageMap': GetImageMapService,
}
